import axios from "axios";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loadCountries } from "../../utils/countryCache";

const AppInit = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const pathname = location.pathname;

  // Load countries cache on app initialization
  useEffect(() => {
    loadCountries().catch((error) => {
      console.error("Error loading countries cache:", error);
    });
  }, []);

  useEffect(() => {
    const apiUrl = `${import.meta.env.VITE_BASE_URL}/clients/user/me`;

    if (!localStorage.getItem("userId")) {
      return;
    }

    const headers = {
      Authorization: localStorage.getItem("userId"),
    };

    axios
      .get(apiUrl, { headers })
      .then((response) => {
        if (!pathname.includes("forgetPassword")) {
          if (response.data.data) {
            localStorage.setItem(
              "companyId",
              response.data.data.meta.companyId
            );
            navigate("/dashboard");
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [localStorage.getItem("userId"), navigate]);

  return <></>;
};

export default AppInit;
